<template>
  <div id="app">
    <component :is="layout"></component>
    <b-overlay
      :show="overlay"
      no-wrap
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
    >
    </b-overlay>
  </div>
</template>

<script>
import DefaultLayout from "./layouts/Default";
import DashboardLayout from "./layouts/Dashboard";
import TryoutLayout from "./layouts/Tryout";
import ForumLayout from "./layouts/Forum";
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";

export default {
  data() {
    return {
      // showOverlay: true
    };
  },
  mounted() {
    this.setOverlay(true);
    setTimeout(() => {
      this.setOverlay(false);
    }, 2000);
  },
  computed: {
    ...mapGetters({
      overlay: types.OVERLAY
    }),
    layout() {
      let layoutName = "dashboard-layout";
      if (this.$route.meta && this.$route.meta.layout) {
        layoutName = this.$route.meta.layout;
      }

      return layoutName;
    }
  },
  methods: {
    ...mapActions({
      setOverlay: types.SET_OVERLAY
    })
  },
  components: {
    DashboardLayout,
    TryoutLayout,
    DefaultLayout,
    ForumLayout
  }
};
</script>

<style>
#app {
  position: relative;
  background: #e3e3e3;
  min-height: 100vh;
}
</style>
